import { useMutation, useQueryClient } from '@tanstack/react-query'

import { INVOICE_REMINDERS_QUERY_KEY } from '@/hooks/useReminders'
import { sendInvoice } from '@/requests/invoices'
import type { SendInvoiceBody } from '@/requests/invoices'

export class AlreadySentError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'AlreadySentError'
  }
}

export function useInvoiceEmailMutation(invoiceId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: async (body: SendInvoiceBody) => {
      const result = await sendInvoice(invoiceId, body)
      if (result.error) {
        if (result.status === 409) throw new AlreadySentError(result.error.message)
        throw new Error(result.error.message)
      }
      return result.data!
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['invoices', invoiceId] })
      // Sending enrols the invoice's reminders.
      await queryClient.invalidateQueries({ queryKey: INVOICE_REMINDERS_QUERY_KEY })
    },
  })
}
